import React from 'react'

export const TumblrIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--social icon--social-tumblr ${props.className || ''}`}
    viewBox='0 0 32 32'
  >
    <path
      d='M22.363,23.945c-0.492,0.236-1.439,0.442-2.145,0.464c-2.13,0.057-2.541-1.499-2.562-2.625v-8.281h5.344V9.476h-5.323V2.7c0,0-3.832,0-3.896,0s-0.177,0.057-0.192,0.199c-0.228,2.074-1.198,5.713-5.234,7.168v3.436h2.692v8.692c0,2.973,2.195,7.202,7.99,7.104c1.955-0.035,4.127-0.853,4.606-1.559L22.363,23.945z'
    />
  </svg>
)
